import { IPlayerGameStats } from "../types/types";

export type MultikillTier = "penta" | "quadra" | "triple" | "double";

type MultikillGame = Pick<
  IPlayerGameStats,
  "doubleKills" | "tripleKills" | "quadraKills" | "pentaKills"
>;

export const getMultikillLabel = (game: MultikillGame): string | null => {
  if ((game.pentaKills ?? 0) > 0) return "Penta";
  if ((game.quadraKills ?? 0) > 0) return "Quadra";
  if ((game.tripleKills ?? 0) > 0) return "Triple";
  if ((game.doubleKills ?? 0) > 0) return "Double";
  return null;
};

export const getMultikillTier = (game: MultikillGame): MultikillTier | null => {
  const label = getMultikillLabel(game);
  if (!label) return null;
  return label.toLowerCase() as MultikillTier;
};

export const hasMultikillData = (games: IPlayerGameStats[]): boolean =>
  games.some((game) => getMultikillLabel(game) != null);
